import { getToken } from '../utils/getToken'

export default {
  getAll,
  getAllIncludingInactive,
  getById,
  create,
  update,
  deactivate,
}

function handleSuccess(result) {
  if (!result.ok) throw new Error(result)
  return result.json()
}

function handleFailure(defaultErrorMessage, err) {
  throw new Error(defaultErrorMessage || err)
}

function authHeaders() {
  return {
    Authorization: `Bearer ${getToken()}`,
    'Content-Type': 'application/json',
    Accept: 'application/json',
  }
}

function getAll() {
  return fetch('/api/casetypes', {
    method: 'GET',
    headers: authHeaders(),
  })
    .then(handleSuccess)
    .catch(err => handleFailure('Unable to retrieve case types.', err))
}

function getAllIncludingInactive() {
  return fetch('/api/casetypes?includeInactive=true', {
    method: 'GET',
    headers: authHeaders(),
  })
    .then(handleSuccess)
    .catch(err => handleFailure('Unable to retrieve case types.', err))
}

function getById(id) {
  return fetch(`/api/casetypes/${id}`, {
    method: 'GET',
    headers: authHeaders(),
  })
    .then(handleSuccess)
    .catch(err => handleFailure('Unable to retrieve case type.', err))
}

function create(model) {
  return fetch('/api/casetypes', {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(model),
  })
    .then(handleSuccess)
    .catch(err => handleFailure('Unable to create case type.', err))
}

function update(id, model) {
  return fetch(`/api/casetypes/${id}`, {
    method: 'PUT',
    headers: authHeaders(),
    body: JSON.stringify(model),
  })
    .then(handleSuccess)
    .catch(err => handleFailure('Unable to update case type.', err))
}

function deactivate(id) {
  return fetch(`/api/casetypes/${id}`, {
    method: 'DELETE',
    headers: authHeaders(),
  })
    .then(result => {
      if (!result.ok) throw new Error(result)
    })
    .catch(err => handleFailure('Unable to deactivate case type.', err))
}
